import styled from "styled-components"

export const AbsencePopupWrapper = styled.div`
	width: 100dvw;
	height: 100dvh;
	display: flex;
	justify-content: center;
	align-items: center;


	.containerPopup {
		position: relative;
		box-shadow: 2px 4px 38px 0px #0000001a;
		background-color: #fff;
		padding: 32px;
		border-radius: 16px;
		width: 487px;

		.header {
			position: absolute;
			top: 16px;
			left: 16px;
		}

		h1 {
			color: #27272a;
			font-size: 18px;
			font-weight: 700;
			line-height: 24px;
			margin-bottom: 16px;
		}

		p {
			color: #71717a;
			font-size: 14px;
			font-weight: 400;
			line-height: 22px;
			margin-bottom: 24px;
		}

		.containerFooter {
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 16px;

			button {
				width: 100%;
				padding: 10px 0;
				border-radius: 12px;
				font-size: 16px;
				font-weight: 600;
				cursor: pointer;
				border: none;
			}

			.confirmBtn {
				background-color: #5b2edd;
				color: white;
			}

			.cancelBtn {
				background-color: transparent;
				color: #5b2edd;
				border: 1px solid #5b2edd;
			}
		}
	}
`
export const CloseIconWrapper = styled.div<{ isRTL: boolean }>`
  position: absolute;
  top: 16px;
  right: 16px;
  direction: ${props => !props.isRTL ? "rtl" : "ltr"};
  width: 90%;
`;
